import React from "react";
import { Link } from "react-router-dom";
import TeacherImg from "../../../asset/images/home/female teacher crossed arms.png";
import earIcon from "../../../asset/images/home/icon/ear.png"; // adjust path if needed

function AudioCard() {
    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">
                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 1: What is the Science of Reading?
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Test your knowledge
                </h3>

                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="ml-2">
                        Click on the letter for the sound that you hear using only the core
                        sound for that letter. For example, C has two sounds. The core sound
                        is contained in the word “cat.” You would not select the S sound for
                        C. You will have 10 seconds to respond. Let’s begin.
                    </p>
                </div>

                {/* Hear Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-32 flex items-center justify-center">
                        <img src={earIcon} height="20" width="20" className="mr-2" alt="Hear" />
                        Hear
                    </button>
                </div>


                {/* Main Card */}
                <div className="max-w-7xl mx-auto">
                    <div className="bg-white border border-primary rounded-xl pt-4 shadow-lg">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                            {/* Left Image */}
                            <div className="flex justify-center">
                                <img
                                    src={TeacherImg}
                                    alt="Virtual Teacher"
                                    className="max-w-full h-auto rounded-lg"
                                />
                            </div>

                            {/* Right Buttons */}
                            <div className="p-3">
                                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-2 justify-items-center">
                                    {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((letter) => (
                                        <button
                                            key={letter}
                                            className="bg-primary text-white rounded-lg py-5 px-6 font-semibold shadow-md text-lg"
                                        >
                                            {letter + letter.toLowerCase()}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Buttons */}
                <div className="flex justify-end mt-5">
                    <Link to="/dashboard/modules/image-or-gif">
                        <button className="px-6 py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8 opacity-50">
                            ← Previous
                        </button>
                    </Link>

                    <Link to="/dashboard/modules/table">
                        <button className="px-6 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium opacity-50">
                            Continue Lesson →
                        </button>
                    </Link>
                </div>
            </main>
        </div>
    );
}

export default AudioCard;
